module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-info_"
  }, [_c('topNav', {
    attrs: {
      "simple-title": true,
      "title": _vm.$t('info_title')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('div', {
    staticClass: "tag ",
    class: {
      active: _vm.getParams.readStatus === null
    },
    on: {
      "click": function($event) {
        return _vm.getInfo(null)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('info_readStatusNull')))]), _vm._v(" "), _c('div', {
    staticClass: "tag",
    class: {
      active: _vm.getParams.readStatus === 0
    },
    on: {
      "click": function($event) {
        return _vm.getInfo(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('info_readStatus0')))]), _vm._v(" "), _c('div', {
    staticClass: "tag",
    class: {
      active: _vm.getParams.readStatus === 1
    },
    on: {
      "click": function($event) {
        return _vm.getInfo(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('info_readStatus1')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.getNextPage),
      expression: "getNextPage"
    }],
    staticClass: "messages l_o_btm",
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "20"
    }
  }, [_vm._l((_vm.msgInfo), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "mess"
    }, [(index == 0 || _vm.diffDay(item.createDatetime, _vm.msgInfo[index - 1].createDatetime)) ? _c('p', {
      staticClass: "msgTime"
    }, [_vm._v("\n        " + _vm._s(_vm._f("datefomate")(item.createDatetime)))]) : _vm._e(), _vm._v(" "), _c('mt-cell-swipe', {
      attrs: {
        "right": [{
            content: _vm.view,
            style: {
              background: 'red',
              color: '#fff',
              borderRight: '1px solid #fff'
            },
            handler: function() {
              _vm.look(item.id)
            }
          },
          {
            content: _vm.deleteString,
            style: {
              background: 'red',
              color: '#fff'
            },
            handler: function() {
              _vm.delMsg(item.id, index)
            }
          }
        ]
      }
    }, [_c('div', {
      staticClass: "msgInfo",
      attrs: {
        "slot": "title"
      },
      on: {
        "click": function($event) {
          return _vm.look(item.id, index)
        }
      },
      slot: "title"
    }, [_c('div', {
      staticClass: "msgTitle"
    }, [_c('i', {
      staticClass: "point",
      class: {
        read: item.readStatus == 1
      }
    }), _vm._v(_vm._s(item.title) + "\n            "), _c('div', {
      staticClass: "right"
    }, [_vm._v(_vm._s(_vm._f("timefomate")(item.createDatetime)))])]), _vm._v(" "), _c('div', {
      staticClass: "msgContent"
    }, [_c('div', {
      staticClass: "msgSummary"
    }, [_vm._v("\n              " + _vm._s(item.overview) + "\n            ")])])])])], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loadingli"
  }, [_c('mt-spinner', {
    attrs: {
      "type": 2
    }
  })], 1), _vm._v(" "), (_vm.msgInfo != undefined && _vm.msgInfo.length > 6 && !_vm.hasNext) ? _c('div', {
    staticClass: "dx"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('loading_end_message')))])]) : _vm._e(), _vm._v(" "), _c('nothing', {
    attrs: {
      "condition": _vm.msgInfo != null && _vm.msgInfo.length == 0
    }
  })], 2), _vm._v(" "), _c('foot-nav', {
    ref: "footnav",
    attrs: {
      "sta": "2"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4d075b10","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/info.vue
// module id = 1786
// module chunks = 107